import * as React from "react";
import { EntryJSON } from "../models/entries";
import { clearQueue, queueSong, playAudio } from "../state";
import { getEntryArtists } from "./SongMetadata";
import { Button } from "../DesignSystem/Button";

interface PlayListProps {
  entries: EntryJSON[];
  desc: string;
}

export class PlayList extends React.Component<PlayListProps> {
  playList(): void {
    if (!this.props.entries || !this.props.entries.length) {
      return;
    }

    clearQueue();

    for (const entry of this.props.entries) {
      if (!entry.uploaded_url) {
        continue;
      }

      queueSong({
        name: entry.title,
        uploaded_url: entry.uploaded_url,
        entry_id: entry.id,
        entry_url: `/entry/${entry.id}`,
        artists: getEntryArtists(entry),
      });
    }

    setTimeout(() => playAudio(), 0);
  }

  render(): JSX.Element {
    return (
      <div className="w-36 inline-block">
        <Button
          icon={
            <i className="fa fa-play text-chips-gold" aria-hidden="true"></i>
          }
          onClick={() => this.playList()}
        >
          {this.props.desc}
        </Button>
      </div>
    );
  }
}
